import { MatCheckboxChange } from '@angular/material/checkbox';
import { Observable, take } from 'rxjs';

import { TableCellAlignmentEnum } from './TableCellAlignmentEnum';
import { TableColumn } from './TableColumn';
import { TableColumnOptions } from './TableColumnOptions';
import { TableColumnType } from './TableColumnType';

export class TableColumnCheckBox extends TableColumn {
  public disabled?: boolean;

  private readonly callback: (
    selectedId: number | null,
    checked: boolean | null,
    selectedItem: [] | null,
  ) => void;

  private _selectedId: number | null;

  private selectAllBoxes: boolean = false;

  private isSelected: boolean = false;

  public isAllChecked: boolean = false;

  private selectedIdsArr: any = [];
  public rowSelectionKey: any = [];
  public showHeaderText: boolean = false;

  public set selectedId(value: number) {
    this._selectedId = value;
  }

  constructor(
    def: string,
    header: string,
    callback: (
      selectedId: number | null,
      checked: boolean | null,
      selectedItem: [] | null,
    ) => void,
    sortable = false,
    width?: number,
    options?: TableColumnOptions,
    checkAll?: (allChecked: boolean) => void,
    disabled?: boolean,
    rowSelectionKey?: string,
    showHeaderText?: boolean,
  ) {
    if (options == null) {
      options = {
        alignment: TableCellAlignmentEnum.CENTER,
        columnType: TableColumnType.CheckBox,
      };
    }

    super(
      def,
      header,
      (_) => '',
      sortable,
      width,
      options,
      (_) => '',
      (_) => '',
    );

    this.disabled = disabled ?? false;
    this.callback = callback;
    this._selectedId = null;
    this.checkAll = checkAll;
    this.rowSelectionKey = rowSelectionKey || 'id';
    this.showHeaderText = showHeaderText ?? false;
  }

  public clickHandler(event: MatCheckboxChange, rowId: number): void {
    this._selectedId = rowId;

    const index = this.selectedIdsArr.indexOf(rowId);

    index === -1
      ? this.selectedIdsArr.push(rowId)
      : this.selectedIdsArr.splice(index, 1);

    this.isAllChecked = false;
    this.callback(this._selectedId, event.checked, this.selectedIdsArr);
  }

  public checkAllboxes(
    event?: MatCheckboxChange,
    data?: Observable<any[]>,
  ): void {
    this.isAllChecked = event?.checked ?? false;
    this.selectAllBoxes = this.isAllChecked;

    if (this.isAllChecked && data) {
      data.pipe(take(1)).subscribe((items) => {
        this.selectedIdsArr = items.map((d) => d.id);
      });
    } else {
      this.selectedIdsArr = [];
    }

    this.checkAll?.(this.selectAllBoxes);
  }

  public showChecked(row?: any): boolean {
    this.isSelected =
      this.selectedIdsArr.indexOf(row.id) >= 0 || row?.[this.rowSelectionKey];
    return this.isSelected;
  }

  public resetCheckBoxes(): void {
    this.isAllChecked = false;
    this.selectedIdsArr = [];
  }
}
